import React, {Fragment} from "react";
import {Box, Divider, Grid, Card, Typography, CardHeader, CardContent, CardProps} from "@mui/material";
import {Balance} from "../../queries";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {formatPrice} from "~/apps/core/utils";


export type ContractCardProps = {
    title: string
    color?: CardProps["color"]
    balances: Balance[]
    active?: boolean
}

const defaultProps: Partial<ContractCardProps> = {
    active: true
}


const useStyles = makeStyles<PortTheme, ContractCardProps>(theme => ({
    header: {
        backgroundColor: props => {
            if (props.color) {
                return theme.palette[props.color].main;
            }
            const color = props.active ? "additionalPrimary": "additionalSecondary";
            return theme.palette[color].main;
        },
        "& .MuiTypography-root": {
            color: "#FFFFFF"
        },
        padding: "10px",
    }
}));


function Item(props: { title: string, children: any, variant?: "vertical" | "horizontal" }) {
    const {title, children, variant} = props;
    const v = variant == "vertical";

    return (
        <Grid container
              spacing={(v ? 0 : 0) as any}
              direction={v ? "column" : "row"}
              justifyContent={v ? "flex-start" : "space-between"}
        >
            <Grid item>
                <Typography variant="inputTitle2" color="secondary">
                    {title}
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="cardText">
                    {children}
                </Typography>
            </Grid>
        </Grid>
    );
}


export const ContractCard = (props: ContractCardProps) => {
    const {title, balances, active} = props;
    const classes = useStyles(props);

    return (
        <Card elevation={4}>
            <CardHeader titleTypographyProps={{ variant: "cardTitle1" }} title={(
                <Grid container direction="row" justifyContent="space-between">
                    <Grid item>
                        {title}
                    </Grid>
                    {!active && (
                        <Grid item>
                            <Typography variant="btnText2">
                                Просрочен
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            )} className={classes.header}/>
            <CardContent>
                <Grid container spacing={2} direction="column">
                    {balances?.length > 0 ? balances.map((balance, index) => (
                        <Fragment key={index}>
                            {index > 0 && (<Grid item><Divider/></Grid>)}
                            <Grid item container direction="column" spacing={1}>
                                <Grid item container>
                                    <Grid item container>
                                        <Grid item flexGrow={1}>
                                            <Typography variant="screenText">
                                                Баланс
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="screenTitle">
                                                {formatPrice(balance.balance)} {balance.currency}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="cardTitle2" color={active ? "additionalPrimary.main" : "secondary"}>
                                            {balance.VATRate.toLowerCase() == "без ндс" ? balance.VATRate : `НДС ${balance.VATRate}`}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Item title="Предварительный резерв">
                                        {formatPrice(balance.deposit)}
                                    </Item>
                                </Grid>
                                <Grid item>
                                    <Item title="Свободный остаток">
                                        {formatPrice(balance.clearBalance)}
                                    </Item>
                                </Grid>
                            </Grid>
                        </Fragment>
                    )) : (
                        <Grid item>
                            <Typography variant="cardText" color="secondary">
                                Нет данных
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    )
}

ContractCard.defaultProps = defaultProps;